export default "__VITE_ASSET__8248b01d__"